export type CurrencyConfig = {
  code: string;
  locale: string;
  symbol: string;
};

const DEFAULT_CURRENCY_CONFIG: CurrencyConfig = {
  code: 'INR',
  locale: 'en-IN',
  symbol: '₹'
};

const normalizeLocale = (locale: string): string => locale.replace('_', '-');

export const formatCompactCurrency = (
  amount: number,
  config: CurrencyConfig = DEFAULT_CURRENCY_CONFIG
): string => {
  if (amount === null || amount === undefined) return '0';

  const locale = normalizeLocale(config.locale);

  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: config.code,
    notation: 'compact',
    compactDisplay: 'short',
    currencyDisplay: 'narrowSymbol'
  });

  return formatter.format(amount);
};

export const formatCurrencyValue = (
  amount: number,
  config: CurrencyConfig = DEFAULT_CURRENCY_CONFIG
): { symbol: string; value: string } => {
  if (amount === null || amount === undefined) {
    return { symbol: config.symbol, value: '0' };
  }

  const locale = normalizeLocale(config.locale);

  const formatter = new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });

  const formattedValue = formatter.format(amount);
  const cleanValue = formattedValue.replace(/\.00$/, '');

  return {
    symbol: config.symbol,
    value: cleanValue
  };
};

export const formatCurrencyFull = (
  amount: number,
  config: CurrencyConfig = DEFAULT_CURRENCY_CONFIG
): string => {
  if (amount === null || amount === undefined) return `${config.symbol}0`;

  const locale = normalizeLocale(config.locale);

  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: config.code,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });

  return formatter.format(amount);
};
